import styled from "styled-components";

// Constants
import { APP_ASSETS_BUCKET_URL } from "constants/common";
import { media } from "utils/media";

// Assets
const spocketLogo = `${APP_ASSETS_BUCKET_URL}/new-spocket-logo.svg`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 32px;
  margin-top: 32px;
  box-sizing: border-box;
  position: absolute;

  ${media.SIDEBAR`
    padding-left: 24px;
  `}
`;

export const Image = styled.img.attrs({ src: spocketLogo, alt: "Spocket logo" })`
  display: flex;
`;
